<h3 class="pt-transaction-donut-total__header">
  <div class="pt-transaction-donut-total__header-text">
    {{ ('transactionDonutTotal.header.' + chart().id) | translate }}
  </div>

  @if (hasSum()) {
    <div class="pt-transaction-donut-total__header-sum">
      {{ donutData().sum }}
      <pt-coin/>
    </div>
  }
</h3>

<div class="pt-transaction-donut-total__content">
  <pu-donut-chart
    class="pt-transaction-donut-total__donut"
    [viewBox]="60"
    [borderSize]="5"
    [gap]="gap()"
    [slices]="donutData().slices"
  />

  <div class="pt-transaction-donut-total__labels">
    @for (metric of chart().metrics; track metric.id) {
      <div class="pt-transaction-donut-total__label">
        <div class="pt-transaction-donut-total__label-wrap">
          <div
            class="pt-transaction-donut-total__label-dot"
            [style.background-color]="colors()[$index]"
          >
          </div>

          <div class="pt-transaction-donut-total__label-text">
            {{ ('transactionDonutTotal.label.' + metric.id) | translate }}
          </div>
        </div>

        <div class="pt-transaction-donut-total__label-sum">
          {{ metric.amount }}
        </div>
      </div>
    }
  </div>
</div>
